import { Phone } from "lucide-react";
import { SITE } from "@/lib/siteConfig";
import { trackConversion } from "@/lib/gtag";

export default function FloatingCallButton() {
  return (
    <a
      href={SITE.phoneHref}
      onClick={() => trackConversion("phone_click_floating")}
      data-testid="call-cta-floating"
      className="lg:hidden fixed bottom-5 right-5 z-50 bg-red-600 hover:bg-red-700 text-white rounded-full w-16 h-16 flex items-center justify-center shadow-2xl pulse-ring"
      aria-label="Appeler SOS Serrurier"
    >
      <Phone className="w-7 h-7" strokeWidth={2.5} />
    </a>
  );
}
